import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const formatNotificationDate = (dateString) => {
  const date = dayjs(dateString);
  const now = dayjs();

  const hoursDiff = now.diff(date, "hour");

  // Show "11 hours ago • 10 Jul" for notifications within 24 hours
  if (hoursDiff < 24) {
    return `${date.fromNow()} • ${date.format("DD MMM")}`;
  }

  // Show "12:23 Am • 26 Dec" for older notifications
  return `${date
    .format("hh:mm A")
    .replace("AM", "Am")
    .replace("PM", "Pm")} • ${date.format("DD MMM")}`;
};
export const formatContentDate = (dateString) => {
  const date = dayjs(dateString);
  // Show "12:23 Am • 26 Dec" for older notifications
  return `${date
    .format("hh:mm A")
    .replace("AM", "Am")
    .replace("PM", "Pm")}`;
};


export const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

export const getTimestampInSeconds = (value) => {
    const normalized = value
      .trim()
      .toLowerCase()
      .replace(/\b(hours?|hour)\b/g, "")
      .replace(/\b(minutes?|mins?|min)\b/g, "")
      .replace(/\b(seconds?|secs?|sec)\b/g, "")
      .trim();

    const parts = normalized.split(":").map(Number);

    if (parts.some(isNaN)) return null;

    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if (parts.length === 3) {
      [hours, minutes, seconds] = parts;
    } else if (parts.length === 2) {
      [minutes, seconds] = parts;
    } else if (parts.length === 1) {
      [seconds] = parts;
    } else {
      return null;
    }

    return hours * 3600 + minutes * 60 + seconds;
  };

export const formatDuration = (seconds) => {
  if (!seconds) return "-";

  if (seconds < 60) {
    return `${seconds} sec`;
  }

  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;

  if (mins < 10) {
    return `${mins}:${secs.toString().padStart(2, "0")} min`;
  }

  return `${mins}:${secs.toString().padStart(2, "0")} min`;
};


export const formatDurationSeconds = (seconds) => {
  if (!seconds && seconds !== 0) return "-";

  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const parts = [];

  if (hours > 0) {
    parts.push(`${hours} hr`);
  }

  if (mins > 0) {
    parts.push(`${mins} min`);
  }

  if (secs > 0 || parts.length === 0) {
    parts.push(`${secs} sec`);
  }

  return parts.join(" ");
};

export default function formatPublishedDate(dateString) {
  return new Date(dateString).toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export const formatWatchTime = (seconds) => {
  if (!seconds && seconds !== 0) return "-";

  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}h: ${String(mins).padStart(2, "0")}m`;
  }

  if (mins > 0) {
    return `${mins}m: ${String(secs).padStart(2, "0")} s`;
  }

  return `${secs} sec`;
};

